import React from 'react';
import { NavLink } from 'react-router-dom'
import request from "../../utils/agent";
import { convertCData, toTitleCase } from "../../utils";
import ReactTable from "react-table";
import Loader from 'components/Loader';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'
import './AdminCsms.scss';

export default class AdminCsms extends React.Component {
  constructor(props) {
    super(props);

      this.state = {
          csms: [],
          loaded: false,
          search:'',
      };
  }

  componentDidMount () {
      request.get("/api/csms")
          .then(resp => {
              this.setState({csms: resp.body.csms, loaded: true});
          })
  };


  render() {

      //console.log('csms', this.state.csms);

      let allCsms = this.state.csms;


      if(this.state.search) {
          allCsms = allCsms.filter(row => {
              return row.first_name.includes(this.state.search) || row.last_name.includes(this.state.search) || row.email.includes(this.state.search) || row.phone.includes(this.state.search)
          })
      }

      const pageOpts = [10, 25, 50, 100];

      const columns = [
          {
              Header: 'Name',
              id: 'name',
              accessor: c => `${c.first_name} ${c.last_name}`,
              className: 'react--tb--styles',
          },
          {
              Header: 'Email',
              id: 'email',
              accessor: c => c.email,
              className: 'react--tb--styles',
          },
          {
              Header: 'Phone',
              id: 'phone',
              accessor: c => c.phone,
              className: 'react--tb--styles',
          },
          {
              Header: 'View',
              className: 'action--tb--styles',
              width: 60,
              Cell:({row, original}) => {
                  return (
                      <Link to={`/admin/csm/${original.id}`} className='view-btn-icon'>
                          <i className='ion-edit'></i>
                      </Link>
                  )
              }
          },
      ];



    return (
        <section className="posrel">
            <div className="col-xs-3 headerBtns">
            <NavLink to="/admin/newCsm" className="btn btn-default btn-primary">New CSM</NavLink>
            </div>
            <h1>CSM Management</h1>
            {this.state.loaded === true ?
                <div className='users-table-hoalder'>
                    <div className='tb-search-holder'>
                        <div className='search--cont'>
                            Search: <input
                            className='tb-search-input'
                            value={this.state.search}
                            onChange={e => this.setState({search: e.target.value})}
                        />
                        </div>
                        <ReactTable
                            data={allCsms}
                            resolveData={allCsms => allCsms.map(row => row)}
                            pageSize={allCsms.length}
                            columns={columns}
                            pageSizeOptions={pageOpts}
                        />
                    </div>
                </div>:
                <div className='loader-hoalder'>
                    <Loader/>
                </div>
            }
        </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/routes/AdminCsms/index.js